import { IGroupedComboBoxGroup } from '../GroupedComboBox/GroupedComboBox.types.shared';
import { GroupStates } from '../GroupedComboBoxDropDown/GroupedComboBoxDropDown.types.shared';

export function isGroupCollapsed(
    group: IGroupedComboBoxGroup,
    groupStates: GroupStates,
    isFiltering: boolean
): boolean | undefined {
    const { groupKey, initiallyCollapsed } = group;

    // If this group has been expanded/collapsed explicitly, honor that state.
    const isCollapsed = groupStates.get(groupKey);
    if (isCollapsed !== undefined) {
        return isCollapsed;
    }

    // Otherwise, expand the group while search is in progress.
    if (isFiltering) {
        return false;
    }

    return initiallyCollapsed;
}
